module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_404", [["div",{"class":"page-404 text-color-1"},[["p",{"class":"p1"},[["textNode",{"text":"404"}]]],["p",{"class":"p2"},[["textNode",{"text":"That’s an error."}]]],["p",{"class":"p2"},[["textNode",{"text":"The requested URL was not found on this server."}]]],["div",{},[["a",{"href":"/","class":"common-btn text-color-3"},[["textNode",{"text":"Go to Main page »"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/404.tpl
// module id = 1173
// module chunks = 4